import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CommonService } from './common.service';
@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient, private commonService: CommonService) { }

  // $: any;

  getTrendingSearch(lang: string, region:string): Observable<any> {
    // return this.http.get<any>(environment.apiURL+"catalog_lists/trending-search.gzip?region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
    return this.http.get<any>(environment.apiURL+"catalog_lists/trending-search.gzip?region="+region+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }
  getSearchResults(params: string, lang: string, region: string,session_id:string): Observable<any> {
    if(lang == 'od') {
      lang = 'od'
    }
    else {
      lang = ''
    }
    return this.http.get<any>(environment.apiURL+"search.gzip?filters=category,all&q="+params+"&region="+region+"&item_language="+lang+"&session_id="+session_id+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }


  getRecentSearch(session: string, clearSearch:boolean): Observable<any> {
    console.log("recent search");
    
    if(clearSearch){
      return this.http.get<any>(environment.apiURL+`users/${session}/search_list?auth_token=${environment.authtoken}&type=clear`)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );  
    }else{
        // {{base_url}}/users/f1803f162cd1344cbf3a4f78c7ca8ce5/search_list?auth_token=jqeGWxRKK7FK5zEk3xCM
    return this.http.get<any>(environment.apiURL+`users/${session}/search_list?auth_token=${environment.authtoken}`)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
    }
    
  }
  // getRecentSearch(session: string, clearSearch: boolean, parentControl: boolean = false): Observable<any> {
  //   let url = `${environment.apiURL}users/${session}/search_list?auth_token=${environment.authtoken}`;
  
  //   // Add `type=clear` if clearSearch is true
  //   if (clearSearch) {
  //     url += '&type=clear';
  //   }
  
  //   // Conditionally add the parental_control parameter
  //   if (parentControl) {
  //     url += '&parental_control=true';
  //   }
  
  //   return this.http.get<any>(url).pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );
  // }
  

  filterPackageSelection(params: string, lang: string, region: string): Observable<any> {
    if(lang == 'od') {
      lang = 'od'
    }
    else {
      lang = ''
    }
    return this.http.get<any>(environment.apiURL+"search.gzip?filters=category,all&q="+params+"&region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken+"&exclude_filters=theme,show_episode$live$event")
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }
 
}
